import React from 'react';
import dayjs from 'libs/dayjs';
import Badge from '../../../global/Badge/Badge';

const tableColumns = () => [
  {
    title: 'Estado',
    key: 'status',
    render: (record) => (
      <Badge color={record.color_status}>{record.status}</Badge>
    ),
    width: '150px',
  },
  {
    title: 'Equipo',
    key: 'elevator',
    dataIndex: 'elevator',
  },
  {
    title: 'Descripción',
    key: 'description',
    dataIndex: 'description',
  },
  {
    title: 'Ultima Modificación',
    key: 'modified_date',
    dataIndex: 'modified_date',
    render: (date) =>
      date ? dayjs(date).format('DD MMMM YYYY') : 'No modificado',
  },
];
export const config = {
  tableColumns,
};

export const hola = '';
